import Vue from 'vue' ;
import VueRouter from 'vue-router'
//2、调用路由对象
Vue.use(VueRouter)

//3、配置路由对象并对外暴露，外部才能使用
export default new VueRouter({
    routes:[
        {
            name: '首页',
            path: '/home',
            component: ()=> import('@/views/home.vue') 
        },
        {
            path: '/',
            redirect: '/home'
        }
    ]
})